<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";
import CopassMenor10 from "@/components/standard/Copass/ConformacionCopass.Menor10";
import CopassMayor10 from "@/components/standard/Copass/ConformacionCopass.Mayor10";
import ListadoCopasst from "./ListadoCopasst";
import CopasstDocumentos from "@/components/standard/Copass/CopasstDocumentos";
import PhotoEvidence from "@/components/standard/PhotoEvidence";
import CompanyAPI from "@/services/company/companyAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "1.1.6 Copasst - vigía de salud",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CopassMenor10,
    CopassMayor10,
    ListadoCopasst,
    CopasstDocumentos,
    PhotoEvidence,
  },
  data() {
    return {
      title: "1.1.6 Copasst - vigía de salud",
       items: [{
        text: 'Estándares',
        href: '/forms/estandares',
      },
      {
        text: '1.1.6 Acta de conformación Copasst Vigía de salud',
        active: true
      },
      ],
      employeeList: 0,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading: true,
    }
  },
  methods: {

    getEmployeesCount() {
      CompanyAPI.employeesCountAct(this.companyID)
        .then((response) => {
          this.employeeList = response.employees || 0
          this.loading = false
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
        })
    },
  },
  mounted() {
    this.getEmployeesCount()
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div v-if="!loading">
      <!-- Informe trimestral de gestión para entrega a la gerencia (SST-FT-033). -->
      <div class="text-right mb-2">
        <router-link
          :to="`/forms/estandares/${companyID}/informe-trimestral-copasst`"
          class="btn btn-primary"
        >
          <i class="mdi mdi-file-document-outline"></i> Informe trimestral para gerencia
        </router-link>
      </div>
      <div class="animated animatedFadeInUp fadeInUp">
        <CopasstDocumentos :companyID="companyID" />
      </div>
      <div v-if="employeeList < 10" class="animated animatedFadeInUp fadeInUp">
        <CopassMenor10 :companyID="companyID" />
      </div>
      <div v-else class="animated animatedFadeInUp fadeInUp">
        <ListadoCopasst :companyID="companyID" />
      </div>
      <div class="animated animatedFadeInUp fadeInUp">
        <PhotoEvidence
          :company-id="companyID"
          item-code="1.1.6"
          category="socializacion"
          title="Evidencia fotográfica de socialización (COPASST / Vigía)"
          help-text="Adjunta fotografías de la socialización, reuniones o votación del COPASST / Vigía de salud."
        />
      </div>
    </div>

    <div v-else>
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>
  </Layout>
</template>
